import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var DoubleChevronRight = createSvgIcon(React__default.createElement(React__default.Fragment, null,
    React__default.createElement("path", { clipRule: "evenodd", d: "M17.5857 11.9289L11.2218 18.2928L12.636 19.707L20.4142 11.9289L12.636 4.15068L11.2218 5.5649L17.5857 11.9289Z", fillRule: "evenodd" }),
    React__default.createElement("path", { clipRule: "evenodd", d: "M11.5857 11.9289L5.22177 18.2928L6.63599 19.707L14.4142 11.9289L6.63599 4.15068L5.22177 5.5649L11.5857 11.9289Z", fillRule: "evenodd" })), 'DoubleChevronRight');

export { DoubleChevronRight };
